export default "__VITE_ASSET__DAXwPbeO__"